export const notifyEvent = payload => {
  const { name = "", detail = {}, data = {} } = payload;
  const event = new CustomEvent(name, { detail, data });
  window.dispatchEvent(event);
};
